import { basicEnum } from "./base";

export const SettlementStatusEnum = basicEnum([
    {
        label: "Menunggu",
        value: "W",
    },
    {
        label: "Disetorkan",
        value: "S",
    },
]);

export namespace SettlementStatusEnum {
    export type Labels = (typeof SettlementStatusEnum)["labels"][number];
    export type Values = (typeof SettlementStatusEnum)["values"][number];
}
